import { generatePath } from "../generatePath";
import type { IExtractParams } from "../types";

const editIntakeFormRoute = "/intake-forms/edit/:id";

export type IEditIntakeFormRouteParam = IExtractParams<
  typeof editIntakeFormRoute,
  string
>;
const viewIntakeFormRoute = "/intake-forms/view/:id";

export type IViewIntakeFormRouteParam = IExtractParams<
  typeof viewIntakeFormRoute,
  string
>;

export const path = {
  list: {
    route: "/intake-forms",
    link: () => path.list.route,
  },
  edit: {
    route: editIntakeFormRoute,
    link: (id?: string) => generatePath(editIntakeFormRoute, { id }),
  },
  view: {
    route: viewIntakeFormRoute,
    link: (id?: string) => generatePath(viewIntakeFormRoute, { id }),
  },
};
